import { tv } from 'tailwind-variants'

export const globalLoadingVariants = tv({
  slots: {
    container: 'flex justify-center items-center top-0 bottom-0 left-0 right-0 absolute',
    loading: 'w-[25px] h-[25px] text-primary-medium'
  }
})
